import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=0473fad8&scoped=true&"
import script from "./BasicPage.vue?vue&type=script&lang=js&"
export * from "./BasicPage.vue?vue&type=script&lang=js&"
import style0 from "./BasicPage.vue?vue&type=style&index=0&id=0473fad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473fad8",
  null
  
)

export default component.exports